import Component from '@glimmer/component';

import { array } from '@ember/helper';
import LinksTo from 'ember-route-state/components/links-to.gjs';

import ExpandingBlock from 'rise-ui/components/expanding-block.gjs';
import string from 'rise-ui/helpers/string.js';

export default class LocationDetailRelatedRecordsComponent extends Component {
  <template>
    <div class="c-related-links__section">
      <h4 class="c-section-title">
        {{string "location-associated-heading"}}
      </h4>
      <div>
        {{#if @location.catalogRecords.length}}
          <div>
            {{#each @location.catalogRecords as | record |}}
              {{#if record.items.length}}
                <ExpandingBlock
                  class="id-location-detail__item-group"
                  @button={{true}}
                  @noHeadExpand={{true}}
                  @iconClass="id-location-detail__item-group-expand-icon"
                >
                  <:head>
                    <LinksTo @route="catalog.record" @model={{record.id}}>
                      {{~record.title~}}
                    </LinksTo>
                  </:head>
                  <:body>
                    <div class="c-related-links__links">
                      {{#each record.groupedItems.ordered as | groupedItems |}}
                        <span>
                          <span class="c-related-links__title">
                            {{groupedItems.type}}
                          </span>
                          {{#each groupedItems.items as | item |}}
                            <div class="c-related-links__link">
                              <span class="id-catalog-record__item-type">
                                {{item.type}}
                              </span>
                              <span class="id-catalog-record__item-title">
                                <LinksTo
                                  @route="catalog.record.item"
                                  @models={{array record.id item.id}}
                                >
                                  {{~item.title~}}
                                </LinksTo>
                              </span>
                            </div>
                          {{/each}}
                        </span>
                      {{else}}
                        <p class="id-catalog-record__no-items-hint">
                          {{string "record-no-items-hint"}}
                        </p>
                      {{/each}}
                    </div>
                  </:body>
                </ExpandingBlock>
              {{else}}
                <div class="c-related-links__link">
                  <LinksTo @route="catalog.record" @model={{record.id}}>
                    {{~record.title~}}
                  </LinksTo>
                </div>
              {{/if}}
            {{/each}}
          </div>
        {{else}}
          <p class="id-location-detail__no-items-hint">
            {{string "location-no-records-hint"}}
          </p>
        {{/if}}
      </div>
    </div>
  </template>
}
